export type EmbedType = 'giving-form' | 'goal-meter';

export const generateEmbed = (
  type: EmbedType,
  embedId: string,
  appsUrl: string
) =>
  `<div id="idonate-${type}-container" data-embed-id="${embedId}"></div>
<script src="${appsUrl}/idonate-${type}.js"></script>`;
